export const create_tray_user = `mutation ($externalUserId: String!, $name: String!) {
  createExternalUser(input: { name: $name, externalUserId: $externalUserId }) {
      userId
  }
}`;

export const get_tray_user = `query ($userCriteria: UserSearchCriteria){
    users (criteria: $userCriteria){
        edges {
            node {
                name
                id
                externalUserId
            }
            cursor
        }
        pageInfo {
          hasNextPage
          endCursor
          hasPreviousPage
          startCursor
        }
    }
}`;

export const login_to_tray = `mutation ($userId: ID!) {
  authorize(input: {
      userId: $userId
  }) {
    accessToken
  }
}`;

export const get_the_solution_instances = `query {
  viewer {
    solutionInstances {
        edges {
            node {
                id
                name
                enabled
                created
                authValues {
                  authId
                  externalId
                }
                configValues {
                  externalId
                  value
                }
                solution {
                    id
                    title
                    description
                    customFields {
                        key
                        value
                    }
                }
            }
        }
    }
  }
}`;

export const get_the_user_auths = `query {
  viewer {
    authentications {
      edges {
        node {
          id
          name
          customFields
          service {
            id,
            name,
            icon,
            title,
            version
          }
          serviceEnvironment {
              id
              title
          }
        }
      }
      pageInfo{
        hasNextPage
        hasPreviousPage
      }
    }
  }
}`;

export const get_all_the_solutions = `query($tags: [String!]) {
  viewer {
    solutions(criteria: { tags: $tags })  {
      edges {
        node {
          id
          title
          description
          customFields {
              key
              value
          }
          tags
        }
      }
    }
  }
}`;

export const create_solution_instance = `mutation ($solutionId: ID!, $instanceName: String!){
   createSolutionInstance(input: {
       solutionId: $solutionId
       instanceName: $instanceName
       authValues: []
       configValues: []
   }) {
     solutionInstance {
       id
       name
       enabled
       created
       authValues {
           authId
           externalId
       }
       configValues {
           value
           externalId
       }
       solution {
           id
           title
           description
           tags
           customFields {
             key
             value
           }
       }
     }
   }
 }`;

export const update_solution_instance_status = `mutation ($solutionInstanceId: ID!, $enabled: Boolean!) {
  updateSolutionInstance(input: {
      solutionInstanceId: $solutionInstanceId,
      enabled: $enabled
  }) {
    solutionInstance {
      id
      name
      enabled
      created
    }
  }
}`;

export const update_solution_instance_name = `mutation ($solutionInstanceId: ID!, $instanceName: String!) {
  updateSolutionInstance(input: {
      solutionInstanceId: $solutionInstanceId,
      instanceName: $instanceName,
  }) {
    solutionInstance {
      id
      name
      enabled
      created
    }
  }
}`;

export const delete_solution_instance = `mutation ($solutionInstanceId: ID!){
   removeSolutionInstance(input: {
       solutionInstanceId: $solutionInstanceId
   }) {
     clientMutationId
   }
 }`;

export const generate_authorization_code = `mutation ($userId: ID!) {
  generateAuthorizationCode( input: {
    userId: $userId
  }) {
    authorizationCode
  }
}`;
